import { render } from "./Promotion12plus3View.vue?vue&type=template&id=6722fbfa&scoped=true"
import script from "./Promotion12plus3View.vue?vue&type=script&lang=js"
export * from "./Promotion12plus3View.vue?vue&type=script&lang=js"

import "./Promotion12plus3View.vue?vue&type=style&index=0&id=6722fbfa&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6722fbfa"]])

export default __exports__